import {getConfiguration} from "@nuskin/configuration-sdk";
import URLService from "./urlService";

const GOOGLE_MAPS_API_URL = "https://maps.googleapis.com/maps/api/js";

/**
 * Promise representing the Google Maps API retrieval and loading process.
 * `undefined` if the process has not yet been initiated.
 * This promise is created only once and returned on all subsequent function calls,
 * in order to avoid loading the Google Maps API script into the page more than once.
 * @type {Promise<void> | undefined}
 */
let apiLoadingPromise;

/**
 * Loader for the Google Maps JavaScript API
 */
export default {
    load
};

/**
 * Loads the Google Maps JavaScript API and Places Library onto the page.
 * Once loaded, the API can be called as described in Google's documentation:
 * https://developers.google.com/maps/documentation/javascript/tutorial
 * @returns {Promise<void>} Promise that is resolved when the Google Maps API has been
 * successfully loaded. Promise is rejected if the API fails to load.
 */
function load() {
    if (!apiLoadingPromise) {
        apiLoadingPromise = new Promise((resolve, reject) => {
            getConfiguration(['Url'])
                .then(({Url: urlCfg}) => {
                    const $script = document.createElement("script");
                    $script.setAttribute("type", "text/javascript");
                    $script.setAttribute("async", "true");
                    $script.onload = () => resolve();
                    $script.onerror = () =>
                        reject(new Error("Google Maps API script failed to load"));
                    const src = `${GOOGLE_MAPS_API_URL}?${URLService.toQueryString({
                        key: urlCfg.googleMapsApiKey,
                        libraries: ["places"]
                    })}`;
                    $script.setAttribute("src", src);
                    document.body.appendChild($script);
                })
                .catch((err) => {
                    reject(new Error(err));
                });
        });
    }
    return apiLoadingPromise;
}
